export const isValidUrl = (urlString: string) => {
  try {
    return Boolean(new URL(urlString));
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (_error) {
    return null;
  }
};

// copy of isValidUrl to remove extra dependencies on myget
export function getRootDomain(hostname?: string): string {
  const url = hostname || window.location.origin;
  if (isValidUrl(url)) {
    const domain = new URL(url);
    const m = domain.hostname.match(
      /^(?:.*?\.)?([a-zA-Z0-9\-_]{3,}\.(?:\w{2,8}|\w{2,4}\.\w{2,4}))$/,
    );
    if (m) {
      return m[1];
    }
  }
  return 'healthcare.com';
}

export function isPharmacy(origin: string) {
  return origin.split('.').some((part) => part === 'pharmacy');
}

export function getCollector(origin: string, isProd: boolean) {
  const appId = getRootDomain();

  if (isPharmacy(origin)) {
    return isProd
      ? 'https://collector.pharmacy.healthcare.com'
      : 'https://collector.dev.pharmacy.healthcare.com';
  }

  if (isProd) {
    return `https://sp.${appId}`;
  }

  const matchQa = origin.match(/(^|\.)qa\./);
  if (matchQa) {
    return `https://spnp.qa.${appId}`;
  }

  const matchStg = origin.match(/(^|\.)stg\./);
  if (matchStg) {
    return `https://spnp.stg.${appId}`;
  }

  const matchLocal = origin.match(/(^|\.)local\./);
  if (matchLocal) {
    return `https://spnp.dev.${appId}`;
  }

  return `https://spnp.dev.${appId}`;
}

type UrlParts = {
  hostname: string;
  path: string;
  query: string;
};

export function getUrlParts(url: string): UrlParts {
  const { hostname, pathname, search } = new URL(url);
  return {
    hostname,
    path: pathname,
    query: search.length > 0 ? search.substring(1) : search,
  };
}
